export default {"src":"/_next/static/media/BMS.d66b707e.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};